import {createRoot} from 'react-dom/client'
import './index.css'
import {SocketProvider} from "./dashboard/SocketContext.jsx";
import {store} from "./store/store.js";
import {Provider} from "react-redux";
import {BrowserRouter as Router} from "react-router-dom";
import {App} from "../App.jsx";

createRoot(document.getElementById('root')).render(
  <Router>


          <Provider store={store}>
              <SocketProvider>
                    <App />
              </SocketProvider>
          </Provider>

  </Router>
)
